type BaseParam = {
  channel: string;
  key: string;
};
enum TypePrefix {
  NUMBER = 'number',
  BOOLEAN = 'boolean',
  STRING = 'string',
  ARRAY = 'array',
  DICTIONARY = 'dictionary',
}
function splitStringAtFirstUnderscore(str: string) {
  // 找到第一个下划线的位置
  const underscoreIndex = str.indexOf('_');

  // 如果没有找到下划线，返回原始字符串和空字符串
  if (underscoreIndex === -1) {
    return [str, ''];
  }

  // 使用 slice 方法将字符串分为两部分
  const part1 = str.slice(0, underscoreIndex);
  const part2 = str.slice(underscoreIndex + 1);

  return [part1, part2];
}
const addPrefix = (prefix, str) => `${prefix}_${str}`;
const identifyType = (val: string) => {
  if (!val) return null;
  const [prefix, value] = splitStringAtFirstUnderscore(val);

  switch (prefix) {
    case TypePrefix.NUMBER:
      return Number(value);
    case TypePrefix.BOOLEAN:
      return value === 'true';
    case TypePrefix.STRING:
      return value;
    case TypePrefix.ARRAY:
      return JSON.parse(value);
    case TypePrefix.DICTIONARY:
      return JSON.parse(value);
    default:
      return null;
  }
};

const baseGet = (obj: BaseParam) => {
  const key = addPrefix(obj.channel, obj.key);
  const val = identifyType(window.localStorage.getItem(key) || '');
  return val;
};

const Storage = {
  setNumber(obj: BaseParam & { value: number; }) {
    const key = addPrefix(obj.channel, obj.key);
    const value = addPrefix(TypePrefix.NUMBER, obj.value);
    window.localStorage.setItem(key, value);
    return true;
  },
  getNumber(obj: BaseParam) {
    return baseGet(obj);
  },
  setBool(obj: BaseParam & { value: boolean; }) {
    const key = addPrefix(obj.channel, obj.key);
    const value = addPrefix(TypePrefix.BOOLEAN, obj.value);
    window.localStorage.setItem(key, value);
    return true;
  },
  getBool(obj: BaseParam) {
    return baseGet(obj);
  },
  setString(obj: BaseParam & { value: string; }) {
    const key = addPrefix(obj.channel, obj.key);
    const value = addPrefix(TypePrefix.STRING, obj.value);
    window.localStorage.setItem(key, value);
    return true;
  },
  getString(obj: BaseParam) {
    return baseGet(obj);
  },
  setArray(obj: BaseParam & { value: Array<any>; }) {
    const key = addPrefix(obj.channel, obj.key);
    const value = addPrefix(TypePrefix.ARRAY, JSON.stringify(obj.value));
    window.localStorage.setItem(key, value);
  },
  getArray(obj: BaseParam) {
    return baseGet(obj);
  },
  setDictionary(obj: BaseParam & { value: object; }) {
    const key = addPrefix(obj.channel, obj.key);
    const value = addPrefix(TypePrefix.DICTIONARY, JSON.stringify(obj.value));
    window.localStorage.setItem(key, value);
  },
  getDictionary(obj: BaseParam) {
    return baseGet(obj);
  },
  remove(obj: BaseParam) {
    const key = addPrefix(obj.channel, obj.key);
    window.localStorage.removeItem(key);
  },
};

export default Storage;
